export default __webpack_public_path__ + "static/media/ls-operator-effort-losses.ea3ffde1.svg";